import { useMutation, useQueryClient } from "@tanstack/react-query"
import { makeUploadDocuments } from "../../domain/use-cases/upload-documents"
import { httpDocumentRepository } from "../../data/repositories/document-repository"

const uploadDocuments = makeUploadDocuments(httpDocumentRepository)

export const useUploadDocuments = (kbId: string) => {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (files: File[]) => uploadDocuments({ kbId, files }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["documents"] }),
  })
}
